import { useState } from "react";

const SectionBox = ({ count, label, style, className }) => (
  <div style={style} className={className}>
    <div className={`${label.toLowerCase()}-count`}>{count}</div>
    <div className={`${label.toLowerCase()}-text`}>{label}</div>
  </div>
);

const LineIndicator = ({ station, number }) => (
  <div className={`line-color line-color-${station === 1 ? "on" : "off"}`}>
    {number}
  </div>
);

const ProdLineCard = ({
  lineData: { LINE_NAME, LGV, FIP, PALLETS, STATION_1, STATION_2 },
  index,
}) => {
  const [isProdLineModalOpen, setIsProdLineModalOpen] = useState(false);

  const lineSeriesNameChecker = (lineName) =>
    lineName.includes("WIP") ? "W" : lineName;

  const getSectionColor = (count, showZeroAsNeutral = false) => {
    if (count >= 8) {
      return { backgroundColor: "#FF0000", color: "white" };
    } else if (count >= 5) {
      return { backgroundColor: "#D7B401", color: "white" };
    } else if (showZeroAsNeutral && count === 0) {
      return { backgroundColor: "#FAFAFA", color: "black" };
    } else {
      return { backgroundColor: "#238749", color: "white" };
    }
  };

  const lgvSectionColor = (count) => getSectionColor(count, true);
  const palletSectionColor = (count) => getSectionColor(count);

  return (
    <div
      key={index}
      onClick={() => setIsProdLineModalOpen(!isProdLineModalOpen)}
      className="line-prod-container"
    >
      <div className="pallets-container">
        <SectionBox
          count={LGV}
          label="LGV"
          style={lgvSectionColor(LGV)}
          className="prod-top-section"
        />
        {FIP ? (
          <div className="prod-middle-section fip-container">
            <div className="fip-section">FIP</div>
          </div>
        ) : null}
        <SectionBox
          count={PALLETS}
          label="Pallet"
          style={palletSectionColor(PALLETS)}
          className="prod-middle-section"
        />
      </div>

      <div className="prod-bottom-section">
        <div className="line-section">
          <div className="tool-tip">
            {lineSeriesNameChecker(LINE_NAME)}
            <span className="tool-tip-text">{LINE_NAME}</span>
          </div>
        </div>
        <LineIndicator station={STATION_1} number={1} />
        <LineIndicator station={STATION_2} number={2} />
      </div>
    </div>
  );
};

export default ProdLineCard;
